__turbopack_context__.v({
  "badge": "TopicsCovered-module__d9QUAG__badge",
  "badgeLabel": "TopicsCovered-module__d9QUAG__badgeLabel",
});
